const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml'

// These check the local name and namespace instead of using `instanceof`, which
// is false for an element created in another window, such as a parent frame or
// an iframe, even after it is inserted here. `tagName` won't do either, because
// it is lowercase in an XHTML document.

/**
 * @param {object} element
 *
 * @returns {boolean} true if the element is an HTML <script>
 */
export function isScript(element) {
  return isHTMLElementNamed(element, 'script')
}

/**
 * @param {object} element
 *
 * @returns {boolean} true if the element is an HTML <iframe>
 */
export function isIframe(element) {
  return isHTMLElementNamed(element, 'iframe')
}

function isHTMLElementNamed(element, localName) {
  return ( element.localName === localName && element.namespaceURI === HTML_NAMESPACE )
}
